/**
 * Estilos customizados para componentes react-select
 * Usado em todas as páginas que utilizam Select do react-select
 */
export const customStyles = {
    container: (base) => ({
        ...base,
        width: '100%',
    }),
    control: (base, state) => ({
        ...base,
        fontSize: "1rem",
        backgroundColor: "#ffffff",
        borderRadius: "0.80rem",
        boxShadow: state.isFocused ? "0 0 0 0.25rem #27485b73" : null,
        borderColor: "#dee2e6",
        "&:hover": {
            borderColor: "#dee2e6"
        },
    }),
    singleValue: (base) => ({
        ...base,
        color: '#000',
        marginTop: '5px',
    }),
    input: (base) => ({
        ...base,
        color: '#adb5bd',
        height: "46px",
        margin: '0px',
        padding: '0px !important',
    }),
    menu: (base) => ({
        ...base,
        backgroundColor: '#fff',
        zIndex: 9999,
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999,
    }),
    option: (base, state) => ({
        ...base,
        color: state.isSelected ? '#3a5a6c' : null,
        backgroundColor: state.isFocused ? '#27485b73' : null,
        "&:active": {
            backgroundColor: "#27485b73"
        },
    }),
};
